module.exports = __webpack_public_path__ + "static/media/S4.56265ad7.webp";